import { setCookie, getCookie } from './utility';

export default class NoShippingModal {
    constructor() {
        this.noShippingModal = $('#no-shipping-modal');
    }

    init() {
        if (!this.noShippingModal.length || getCookie('noShippingModal')) return;
        this.noShippingModal.modal('show');
        this.onQuitModal();
    }

    onQuitModal() {
        this.noShippingModal.on(
            'hidden.bs.modal',
            setCookie.bind(this, 'noShippingModal', 'shown', 30),
        );
    }
}
